// Филиалы в запросах к API — план 106 (мультивыбор в шапке).
//
// Один параметр `branch_ids` со значениями через запятую: ровно то, что
// понимает серверный `BranchIdsCsvSchema`. Повторённый параметр
// (`?branch_ids=a&branch_ids=b`) сервер разбирает по-разному при одном и двух
// значениях — на этом уже ловились тихие баги, поэтому форма одна.
//
// Пустой список = «Все филиалы» и выражается ОТСУТСТВИЕМ параметра: пустая
// строка `branch_ids=` упрётся в серверную валидацию (400), и это правильно —
// почти всегда она означает баг сборки ссылки, а не «покажи всё».

/** Проставить филиалы в готовые параметры запроса (пустой список — не ставим). */
export function setBranchParams(sp: URLSearchParams, branchIds: string[] | undefined): void {
  if (branchIds && branchIds.length > 0) sp.set('branch_ids', branchIds.join(','));
}

/** Кусок query-строки: `?branch_ids=a,b` либо пусто. */
export function branchQueryString(branchIds: string[] | undefined): string {
  if (!branchIds || branchIds.length === 0) return '';
  return `?branch_ids=${encodeURIComponent(branchIds.join(','))}`;
}

/** Поле для тела/параметров-объектов: `{ branchIds }` либо `{}`. */
export function branchParamsObject(branchIds: string[] | undefined): { branchIds?: string[] } {
  return branchIds && branchIds.length > 0 ? { branchIds } : {};
}
